const purchaseHistoryEN = {
    "view": {
        "table": {
            "title": "Your purchase history",
            "column": {
                "amount": "Amount",
                "description": "Description",
                "credits_balance": "Credits Balance",
                "tokens_balance": "Tokens Balance",
                "date_of_purchase": "Date of Purchase",
                "receipt": "Receipt"
            },
            "placeholder": {
                "search": "Search..."
            },
            "button": {
                "view": "View",
                "export_csv": "Export CSV"
            },
        },
    }
};

export default purchaseHistoryEN;